// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlexContainerIndividuals {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    align-content: start;
    width: 100%;
    /* background-color: #2f1d58; */
    height: 100%;
    overflow: auto;
    flex-direction: row;
}

.FlexContainerIndividuals .cont-globe {
    width: 50%;
    height: 280px;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.titleIndividuals{
    height: 10% !important;
    background-color: var(--third-color);
    border-radius: 10px 10px 0px 0px;
    color: var(--white-color) !important;
    text-align: center;
}
.individualsInfo{
    height: 15%;
    width: 100%;
    display: flex;
    border-bottom: 1px solid var(--border-table-color);
}
.txt-info-individual{
    height: 100%;
    width: 80%;
    display: flex;
    justify-content: start;
    align-items: center;
    color: var(--txt-color);
    left: 3%;
    position: relative;
}
.value-info-individual{
    height: 100%;
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.tooltip-content-individuals {
    visibility: hidden;
    width: 200px;
    background-color: #555555b0;
    color: var(--white-color);
    text-align: left;
    padding: 10px;
    border-radius: 5px;
    position: absolute;
    z-index: 5;
   
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    font-size: var(--font-size-small);
  }
  
  .tooltip-container-individuals:hover .tooltip-content-individuals {
    visibility: visible !important; 
    opacity: 1 !important;
  }
  .tooltip-container-individuals:hover {
   cursor: pointer;
   /* background-color: red; */
  }
 .cont-list-metrics{
    position: relative;
    width: 100%;
    height: 70%;
    display: block;
    overflow: auto;
 }
 .cont-btn-historical{
    background-color: rgba(176, 176, 176, 0.282);
    border-radius: 0px 0px 10px 10px;
    color: var(--main-color)
 }
 .cont-btn-historical:hover{
    background-color: var(--border-table-color);
    cursor: pointer;
 }


 /* Aumento - color verde */
/* .animate-increase-device {
    animation: highlightIncrease 1s ease;
  }
  
  @keyframes highlightIncrease {
    0% {
      background-color: #d4f8d4; 
    }
    100% {
      background-color: transparent;
    }
  } */
  
  /* Disminución - color rojo */
  /* .animate-decrease-device {
    animation: highlightDecrease 1s ease;
  }
  
  @keyframes highlightDecrease {
    0% {
      background-color: #f8d4d4;
    }
    100% {
      background-color: transparent;
    }
  } */
  .animate-change-device {
    animation: highlightChange 3s ease;
  }
  
  @keyframes highlightChange {
    0% {
      background-color: #75c8ff87; /* Azul claro */
    }
    100% {
      background-color: transparent;
    }
  }


  /* .ver-detalle-demo {
  background: linear-gradient(
    270deg,
    #e4e4e4,
    #94e5e8,
    #e4e4e4
  );
  background-size: 400% 400%;
  animation: gradientMove 6s ease infinite;
  color: white;
  border: none;
  
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.ver-detalle-demo:hover {
  transform: scale(1.05);
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
} */
.ver-detalle-demo {
  background: linear-gradient(
    270deg,
    var(--second-color),
    rgb(143, 205, 255),
     var(--second-color)
  );
  background-size: 400% 400%;
  animation: gradientMove 2s ease infinite;

  color: white;
  border: none;
  z-index: 5;
  /* padding: 10px 22px; */
  /* border-radius: 3px; */
  cursor: pointer;

  font-weight: 500;
  letter-spacing: 0.5px;

  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

/* Hover */
/* .ver-detalle-demo:hover {
  transform: translateY(-2px) scale(1.05);
} */

/* Gradient animado */
@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Glow pulsante */
@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 6px rgba(17, 224, 239, 0.4);
  }
  50% {
    box-shadow: 0 0 22px rgba(17, 224, 239, 0.9);
  }
  100% {
    box-shadow: 0 0 6px rgba(17, 224, 239, 0.4);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/styles/Individuals.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;IAChC,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,kDAAkD;AACtD;AACA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;;IAEV,2BAA2B;IAC3B,UAAU;IACV,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;GACC,eAAe;GACf,2BAA2B;EAC5B;CACD;IACG,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;CACjB;CACA;IACG,4CAA4C;IAC5C,gCAAgC;IAChC;CACH;CACA;IACG,2CAA2C;IAC3C,eAAe;CAClB;;;CAGA,0BAA0B;AAC3B;;;;;;;;;;;KAWK;;EAEH,6BAA6B;EAC7B;;;;;;;;;;;KAWG;EACH;IACE,kCAAkC;EACpC;;EAEA;IACE;MACE,2BAA2B,EAAE,eAAe;IAC9C;IACA;MACE,6BAA6B;IAC/B;EACF;;;EAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+BC;AACH;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,wCAAwC;;EAExC,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;;EAEf,gBAAgB;EAChB,qBAAqB;;EAErB,uDAAuD;AACzD;;AAEA,UAAU;AACV;;GAEG;;AAEH,qBAAqB;AACrB;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,6BAA6B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,kBAAkB;AAClB;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;AACF","sourcesContent":[".FlexContainerIndividuals {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: start;\r\n    align-items: center;\r\n    align-content: start;\r\n    width: 100%;\r\n    /* background-color: #2f1d58; */\r\n    height: 100%;\r\n    overflow: auto;\r\n    flex-direction: row;\r\n}\r\n\r\n.FlexContainerIndividuals .cont-globe {\r\n    width: 50%;\r\n    height: 280px;\r\n    margin-top: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.titleIndividuals{\r\n    height: 10% !important;\r\n    background-color: var(--third-color);\r\n    border-radius: 10px 10px 0px 0px;\r\n    color: var(--white-color) !important;\r\n    text-align: center;\r\n}\r\n.individualsInfo{\r\n    height: 15%;\r\n    width: 100%;\r\n    display: flex;\r\n    border-bottom: 1px solid var(--border-table-color);\r\n}\r\n.txt-info-individual{\r\n    height: 100%;\r\n    width: 80%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    left: 3%;\r\n    position: relative;\r\n}\r\n.value-info-individual{\r\n    height: 100%;\r\n    width: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    overflow: auto;\r\n}\r\n\r\n.tooltip-content-individuals {\r\n    visibility: hidden;\r\n    width: 200px;\r\n    background-color: #555555b0;\r\n    color: var(--white-color);\r\n    text-align: left;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    position: absolute;\r\n    z-index: 5;\r\n   \r\n    transform: translateX(-50%);\r\n    opacity: 0;\r\n    transition: opacity 0.3s;\r\n    font-size: var(--font-size-small);\r\n  }\r\n  \r\n  .tooltip-container-individuals:hover .tooltip-content-individuals {\r\n    visibility: visible !important; \r\n    opacity: 1 !important;\r\n  }\r\n  .tooltip-container-individuals:hover {\r\n   cursor: pointer;\r\n   /* background-color: red; */\r\n  }\r\n .cont-list-metrics{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 70%;\r\n    display: block;\r\n    overflow: auto;\r\n }\r\n .cont-btn-historical{\r\n    background-color: rgba(176, 176, 176, 0.282);\r\n    border-radius: 0px 0px 10px 10px;\r\n    color: var(--main-color)\r\n }\r\n .cont-btn-historical:hover{\r\n    background-color: var(--border-table-color);\r\n    cursor: pointer;\r\n }\r\n\r\n\r\n /* Aumento - color verde */\r\n/* .animate-increase-device {\r\n    animation: highlightIncrease 1s ease;\r\n  }\r\n  \r\n  @keyframes highlightIncrease {\r\n    0% {\r\n      background-color: #d4f8d4; \r\n    }\r\n    100% {\r\n      background-color: transparent;\r\n    }\r\n  } */\r\n  \r\n  /* Disminución - color rojo */\r\n  /* .animate-decrease-device {\r\n    animation: highlightDecrease 1s ease;\r\n  }\r\n  \r\n  @keyframes highlightDecrease {\r\n    0% {\r\n      background-color: #f8d4d4;\r\n    }\r\n    100% {\r\n      background-color: transparent;\r\n    }\r\n  } */\r\n  .animate-change-device {\r\n    animation: highlightChange 3s ease;\r\n  }\r\n  \r\n  @keyframes highlightChange {\r\n    0% {\r\n      background-color: #75c8ff87; /* Azul claro */\r\n    }\r\n    100% {\r\n      background-color: transparent;\r\n    }\r\n  }\r\n\r\n\r\n  /* .ver-detalle-demo {\r\n  background: linear-gradient(\r\n    270deg,\r\n    #e4e4e4,\r\n    #94e5e8,\r\n    #e4e4e4\r\n  );\r\n  background-size: 400% 400%;\r\n  animation: gradientMove 6s ease infinite;\r\n  color: white;\r\n  border: none;\r\n  \r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.ver-detalle-demo:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n@keyframes gradientMove {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n} */\r\n.ver-detalle-demo {\r\n  background: linear-gradient(\r\n    270deg,\r\n    var(--second-color),\r\n    rgb(143, 205, 255),\r\n     var(--second-color)\r\n  );\r\n  background-size: 400% 400%;\r\n  animation: gradientMove 2s ease infinite;\r\n\r\n  color: white;\r\n  border: none;\r\n  z-index: 5;\r\n  /* padding: 10px 22px; */\r\n  /* border-radius: 3px; */\r\n  cursor: pointer;\r\n\r\n  font-weight: 500;\r\n  letter-spacing: 0.5px;\r\n\r\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\r\n}\r\n\r\n/* Hover */\r\n/* .ver-detalle-demo:hover {\r\n  transform: translateY(-2px) scale(1.05);\r\n} */\r\n\r\n/* Gradient animado */\r\n@keyframes gradientMove {\r\n  0% { background-position: 0% 50%; }\r\n  50% { background-position: 100% 50%; }\r\n  100% { background-position: 0% 50%; }\r\n}\r\n\r\n/* Glow pulsante */\r\n@keyframes pulseGlow {\r\n  0% {\r\n    box-shadow: 0 0 6px rgba(17, 224, 239, 0.4);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 22px rgba(17, 224, 239, 0.9);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 6px rgba(17, 224, 239, 0.4);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
